/**
 * Opens the Gorgias chat from any element whose aria-label is exactly "Chat": footer menu links,
 * Button blocks, the CS page squares (blocks/ai_gen_block_fe8b2ae.liquid) and so on. One delegated
 * listener covers the whole page, including markup added after load.
 *
 * The click never navigates, whatever the href. It is handled in the capture phase and stopped there,
 * so a wrapping link or card handler doesn't act on it either. If the Gorgias widget hasn't finished
 * loading, the chat opens once it has. This is the GorgiasChat.init() / `gorgias-widget-loaded`
 * pattern from Gorgias's chat widget API.
 */
(() => {
  // Guards against a second listener if the script runs twice (theme editor reloads, section refreshes).
  if (window.__gorgiasChatTriggerInit) return;
  window.__gorgiasChatTriggerInit = true;

  const TRIGGER_SELECTOR = '[aria-label="Chat"]';

  /** Resolves once the Gorgias chat widget is ready to open. */
  function gorgiasChatReady() {
    if (window.GorgiasChat && typeof window.GorgiasChat.init === 'function') {
      return window.GorgiasChat.init();
    }
    return new Promise((resolve) => {
      window.addEventListener('gorgias-widget-loaded', () => resolve(), { once: true });
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target instanceof Element ? event.target.closest(TRIGGER_SELECTOR) : null;
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();

      gorgiasChatReady()
        .then(() => window.GorgiasChat.open())
        .catch((error) => console.warn('Gorgias chat could not be opened', error));
    },
    true
  );
})();
